import React, { useState, useEffect } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios"; // Make sure axios is installed
const base_url = process.env.REACT_APP_API_URL;

const Profile = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [userData, setUserData] = useState(null);
  const [idData, setIdData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Fetch profile data
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const auth = localStorage.getItem("admin");
        const response = await axios.get(
            base_url + "/admin/profile",
            {
              headers: {
                "content-type": "application/json",
                "Authorization": `${auth}`,
              },
            }
          );
          console.log(response.data.idRows,"response")
        if (response.data.success) {
          setUserData(response.data.user ); // Assuming the first row is the user data
          setIdData(response.data.idRows[0])
        } else {
          setError(response.data.message);
        }
      } catch (err) {
        setError('Failed to fetch profile data');
        console.error('Error fetching profile:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="wrapper">
      {/* Main Sidebar */}
      <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        {/* Header - Pass mobile info */}
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
        <div className="container-fluid">
          <h5 className="m-0 fw-bold  text-dark">Profile Overview</h5>
        </div>

        <section className="content p-4">
          {/* Personal Information */}
          <div className="card mb-4">
            <div className="card-header bg-dark text-white">
              <h6 className="mb-0 fw-bold">Personal Information</h6>
            </div>
            <div className="card-body">
              <div className="row mb-2">
                <div className="col-md-6 mb-3">
                  <small className="text-muted  fw-bold">ID:</small>
                  <div>{userData?.id}</div>
                </div>
                <div className="col-md-6 mb-3">
                  <small className="text-muted  fw-bold">ID_Created By :</small>
                  <div>{idData?.id}</div>
                </div>
                <div className="col-md-6 mb-3">
                  <small className="text-muted fw-bold">Name</small>
                  <div>{userData?.username}</div>
                </div>
                <div className="col-md-6 mb-3">
                  <small className="text-muted  fw-bold">Role</small>
                  <div>{userData?.role}</div>
                </div>
                <div className="col-md-6 mb-3">
                  <small className="text-muted  fw-bold">Contact Number</small>
                  <div>{userData?.phone}</div>
                </div>
                <div className="col-md-6 mb-3">
                  <small className="text-muted  fw-bold">Password</small>
                  <div>{userData?.plain_password}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Balance & Performance */}
          <div className="card mb-4">
            <div className="card-header bg-dark text-white">
              <h6 className="mb-0  fw-bold">Balance & Performance</h6>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <small className="text-muted  fw-bold">Current Balance</small>
                  <div className="h5">₹{Number(userData?.money || 0).toLocaleString()}</div>
                </div>
                <div className="col-md-6 mb-3">
                  <small className="text-muted  fw-bold">Profit/Loss</small>
                  <div className="h5 d-flex align-items-center">
                    <i className={`fas fa-arrow-${Number(userData?.profitLoss || 0) >= 0 ? 'up text-success' : 'down text-danger'} me-2`}></i>
                    ${Math.abs(Number(userData?.profitLoss || 0)).toLocaleString()}
                  </div>
                </div>
              </div>
            </div>
        </div>

          {/* Rewards & Bonuses */}
          <div className="card">
            <div className="card-header bg-dark text-white">
              <h6 className="mb-0  fw-bold">Rewards & Bonuses</h6>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <small className="text-muted  fw-bold">Current Bonus</small>
                  <div className="h5">${Number(userData?.bonus || 0).toLocaleString()}</div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <a
        id="back-to-top"
        href="##"
        className="btn btn-primary back-to-top"
        role="button"
        aria-label="Scroll to top"
      >
        <i className="fas fa-chevron-up" />
      </a>
    </div>
  );
};

export default Profile;